<style lang="stylus">
    .usertask-modal
        width 100vw
        height 100vh
        z-index 100
        pointer-events auto

        .usertask-mask
            modal-mask()

        .usertask-modalbox
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            width 640px
            height 480px
            border-radius 8px
            background #fff
            z-index 1000

            .usertask-modal-bg
                position absolute
                top 0
                left 0
                pointer-events none
                z-index -1

            .usertask-modal-head
                display flex
                justify-content space-between
                height 40px
                padding 12px 20px

                .usertask-modal-title
                    font-size 14px
                    line-height 16px
                    font-weight 700
                    color #000

                .usertask-modal-close
                    display flex
                    justify-content center
                    align-items center
                    width 16px
                    height 16px
                    cursor pointer

            .usertask-modal-description
                width 100%
                padding 0 20px
                margin-top 8px
                margin-bottom 8px

                p
                    font-size 14px
                    line-height 20px
                    color #000
</style>

<template>
    <div class="usertask-modal" v-if="show">
        <div class="usertask-mask"></div>
        <div class="usertask-modalbox">
            <img class="usertask-modal-bg" src="@/public/img/task/modalbg.png" alt="" />
            <div class="usertask-modal-head">
                <p class="usertask-modal-title">{{ title }}</p>
                <div class="usertask-modal-close" @click="closeModal">
                    <img src="@/public/img/task/close.svg" alt="" />
                </div>
            </div>

            <div class="usertask-modal-description">
                <p>{{ content }}</p>
            </div>

            <div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class UserTaskModal extends Vue {
        @Prop()
        title;
        @Prop()
        content;
        @Prop()
        show;

        closeModal() {
            this.$emit("closeModal");
        }

        mounted() {}

        created() {}
    }
</script>
